/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormResponse } from '../models/FormResponse';
import type { FormResponseDto } from '../models/FormResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormResponsesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all responses to a form.
     * @param orgGuid
     * @param formDefinitionGuid The form's guid.
     * @returns FormResponseDto OK
     * @throws ApiError
     */
    public getAllFormResponses(
        orgGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<Array<FormResponseDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{orgGuid}/{formDefinitionGuid}/GetAllFormResponses',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Check if this form definition has any responses.
     * @param orgGuid
     * @param formDefinitionGuid
     * @returns boolean OK
     * @throws ApiError
     */
    public hasResponses(
        orgGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/mwforms/{orgGuid}/{formDefinitionGuid}/HasResponses',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new response to a form.
     * @param orgGuid
     * @param formDefinitionGuid The form's guid.
     * @param userGuid
     * @returns FormResponse OK
     * @throws ApiError
     */
    public createFormResponse(
        orgGuid: string,
        formDefinitionGuid: string,
        userGuid?: string,
    ): CancelablePromise<FormResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{orgGuid}/{formDefinitionGuid}/CreateFormResponse',
            path: {
                'orgGuid': orgGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            query: {
                'userGuid': userGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
